
interface CategoryDescriptionProps {
  categoryId: string;
}

export const CategoryDescription = ({ categoryId }: CategoryDescriptionProps) => {
  const descriptions = {
    ai: "Connect AI services for intelligent automation, content generation, and advanced analysis capabilities.",
    recruiting: "Integrate with recruiting platforms to source candidates and expand your talent pipeline.",
    communication: "Connect email services for message synchronization and automated communication workflows.",
    calendar: "Sync calendar services to manage scheduling, events, and availability across platforms.",
    tools: "Utility services for enhanced functionality including email delivery and data enrichment."
  };

  return <span>{descriptions[categoryId as keyof typeof descriptions] || "Configure platform integrations for enhanced functionality."}</span>;
};
